import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../img/logo-square.png'; // Import the SVG file
/*import { UserContext } from '../../lib/usercontext';
import { signOut } from '../../lib/cognitoutils';
import { useNavigate } from 'react-router-dom';*/

const ExternalLayout = ({ children, pageTitle }) => {
  // const navigate = useNavigate();
  // const { user } = useContext(UserContext);

  // const [setIsLoggedIn] = useState(false);

  /**const handleSignout = async (event) => {
    event.preventDefault();
    try {
      await signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };*/

  return (
    <div className="App">
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img src={Logo} alt="Logo" className="mx-auto h-20 w-auto" />
        </div>
        <div className="min-h-full">
          <header className="bg-white shadow">
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold tracking-tight text-gray-900">{pageTitle}</h1>
            </div>
          </header>
          <main>
            <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

ExternalLayout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string,
};

export default ExternalLayout;
